import React, { useState, useRef, useEffect } from 'react';
import { Box, CardMedia } from '@mui/material';

export const LazyImage = ({ imageUrl, ...props }) => {
  const [isVisible, setIsVisible] = useState(false);
  const imageRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      {
        rootMargin: '50px'  // Start loading when image is 50px from viewport
      }
    );

    if (imageRef.current) {
      observer.observe(imageRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <Box ref={imageRef} sx={{ height: props.sx?.height || 'auto' }}>
      {isVisible && (
        <CardMedia
          component="img"
          image={imageUrl}
          {...props}
        />
      )}
    </Box>
  );
}; 